import { request } from "./client";

export function fetchDreamcastSettings() {
  return request("/settings");
}

export function updateDreamcastSettings(body) {
  return request("/settings", {
    method: "PUT",
    body: JSON.stringify(body),
  });
}
